"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _error = _interopRequireDefault(require("@digital-hig/icon/lib/build/display-icons/error"));

var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));

var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));

var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));

var _complete = _interopRequireDefault(require("@digital-hig/icon/lib/build/display-icons/complete"));

var _svgIcon = _interopRequireDefault(require("@digital-hig/svg-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormControl = function FormControl(_ref) {
  var children = _ref.children,
      error = _ref.error,
      helperText = _ref.helperText,
      hintText = _ref.hintText,
      id = _ref.id,
      InputLabelProps = _ref.InputLabelProps,
      label = _ref.label,
      required = _ref.required,
      success = _ref.success,
      otherProps = _objectWithoutProperties(_ref, ["children", "error", "helperText", "hintText", "id", "InputLabelProps", "label", "required", "success"]);

  return /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    error: error,
    required: required
  }, otherProps), label && /*#__PURE__*/_react.default.createElement(_InputLabel.default, _extends({
    htmlFor: id,
    id: id ? "".concat(id, "-label") : undefined,
    required: required
  }, InputLabelProps), label, hintText && /*#__PURE__*/_react.default.createElement("span", {
    className: "DhigInputLabel--hintText"
  }, hintText)), children, helperText && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    id: id ? "".concat(id, "-helper-text") : undefined,
    error: error,
    className: success ? "MuiFormHelperText--success" : undefined
  }, error && /*#__PURE__*/_react.default.createElement(_svgIcon.default, {
    id: "dhig--ui-controls--error",
    title: "Error"
  }, /*#__PURE__*/_react.default.createElement(_error.default, null)), success && /*#__PURE__*/_react.default.createElement(_svgIcon.default, {
    id: "dhig--ui-controls--complete",
    title: "Success"
  }, /*#__PURE__*/_react.default.createElement(_complete.default, null)), helperText));
};

var defaultProps = {
  error: false,
  label: "",
  hintText: "",
  required: false,
  success: false
};
exports.defaultProps = defaultProps;
FormControl.propTypes = {
  /**
   * Wrapped form element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Determines if error state is used.
   */
  error: _propTypes.default.bool,

  /**
   * Text passed in below the form element. Helper text can be neutral, success, or error.
   */
  helperText: _propTypes.default.string,

  /**
   * The id of the input element. Use this prop to make label and helperText accessible for screen readers.
   */
  id: _propTypes.default.string,

  /**
   * Additional props for InputLabel.
   */
  InputLabelProps: _propTypes.default.object,

  /**
   * The label content.
   */
  label: _propTypes.default.node,

  /**
   * Hint text, which can communicate that the field is optional.
   */
  hintText: _propTypes.default.string,

  /**
   * If component is required.
   */
  required: _propTypes.default.bool,

  /**
   * Determines if success state is used.
   */
  success: _propTypes.default.bool
};
FormControl.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormControl",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "Wrapped form element."
    },
    "error": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Determines if error state is used."
    },
    "helperText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text passed in below the form element. Helper text can be neutral, success, or error."
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The id of the input element. Use this prop to make label and helperText accessible for screen readers."
    },
    "InputLabelProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Additional props for InputLabel."
    },
    "label": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "The label content."
    },
    "hintText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Hint text, which can communicate that the field is optional."
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If component is required."
    },
    "success": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Determines if success state is used."
    }
  }
};
var _default = FormControl;
exports.default = _default;